import { EditTutorials } from "./EditTutorials";
import EditTutorialsRouter from "./EditTutorialsRouter";
import TutorialsService from "@app/tutorials/tutorialsService";

export {
  EditTutorialsRouter,
  TutorialsService,
  EditTutorials,
};
